class Ev {
  constructor(row) {
    this.hold = row[0];
    this.holdBitCodeL2R = this.wasmResult2BitCodeL2R(row[0]);
    this.ev = parseFloat(row[1]);
    this.sd = parseFloat(row[2]);
  }

  // works on wasmResult that is a string or a integer like '27'
  wasmResult2BitCodeL2R(wasmResult) {
    return parseInt(wasmResult).toString(2).padStart(5, '0').split("").reverse();
  }

  toString() {
    return `${this.holdBitCodeL2R.join('')} ${this.ev} ${this.sd}`
  }
}

export default Ev